import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '../contexts/useMsal';
import TestFabricJsonViewer from '../components/TestFabricJsonViewer';

export default function TestFabricPage() {
  const navigate = useNavigate();
  const { getAccessToken } = useMsal();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [jsonData, setJsonData] = useState<any>(null);


  const handlePullTestData = async () => {
    setLoading(true);
    setError('');
    try {
      const userToken = await getAccessToken();
      
      const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5123';
      const response = await fetch(`${apiUrl}/fabric/get-test-data`, {
        headers: {
          'Authorization': `Bearer ${userToken}`
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      setJsonData(data);
      console.log('[TestFabricPage] Test data retrieved:', data);
    } catch (err: any) {
      const errorMsg = err.message || 'Failed to pull test data';
      console.error('[TestFabricPage] Pull test data error:', errorMsg);
      setError(errorMsg);
      setJsonData({ error: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lookup-page">
      <div className="breadcrumb">
        <button 
          onClick={() => navigate('/')} 
          className="breadcrumb-link"
          aria-label="Back to main menu"
        >
          ← Back to Menu
        </button>
        <span className="breadcrumb-separator" aria-hidden="true">/</span>
        <span className="breadcrumb-current">Test Fabric Account Management</span>
      </div>
      <div className="page-header">
        <h1>Test Fabric Lookup Data Management</h1>
        <button
          onClick={handlePullTestData}
          disabled={loading}
          className="btn-primary"
        >
          {loading ? 'Loading...' : 'Pull data from dummy table'}
        </button>
      </div>

      {error && (
        <div className="error-banner">
          <strong>Error:</strong> {error}
          <button onClick={() => setError('')} className="close-btn">×</button>
        </div>
      )}

      <TestFabricJsonViewer jsonData={jsonData} />
    </div>
  );
}
